import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function Stats() {
  const { t } = useTranslation();
  const stats = t('stats.items', { returnObjects: true }) as Array<{ number: string; label: string }>;

  return (
    <section className="py-20 bg-on-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {stats.map((stat, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
            >
              <p className="text-5xl md:text-6xl font-bold text-primary-container mb-2">{stat.number}</p>
              <p className="text-white/70 text-sm uppercase tracking-widest font-medium">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
